import React, {useState, useEffect} from "react";
import {Col, Container, Row, ButtonGroup, DropdownItem, UncontrolledDropdown, DropdownMenu, DropdownToggle} from "reactstrap";
import Widget from "./Widgets";
import Revenue from "./Revenue";
import Section from "./Section";
import { useDispatch} from "react-redux";
import {useProfile} from "../../../Components/Hooks/UserHooks";
import { useLocation } from "react-router-dom";
import {
    getReportProject as onGetReportProject,
} from "../../../slices/thunks";

const ProjectReporting = () => {

  const location = useLocation();
    const projectId = location.pathname.split('/').pop();
  const [project, setProject] = useState([]);
  const [settledPrices, setSettledPrices] = useState([]);
  const [projectPrices, setProjectPrices] = useState([]);

  const [rightColumn, setRightColumn] = useState(true);
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("All");

  const toggleRightColumn = () => setRightColumn(!rightColumn);
  const dispatch = useDispatch();
    const {userProfile} = useProfile();

  useEffect(() => {
    setLoading(true);

    if (userProfile) {
        dispatch(onGetReportProject(projectId))
          .then((response) => {
          setProject(response.payload.project || []);
          setSettledPrices(response.payload?.settled_prices || []);
          setProjectPrices(response.payload?.project_details || []);
          const updatedOptions = [
            ...new Set(
              response.payload?.project_details.map((item) => item.block_name)
            ),
            "All",
          ];
          setOptions(updatedOptions);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [dispatch, projectId, userProfile]);

  const handleSelect = (option) => {
    setSelectedOption(option);
  };

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                                <Section rightClickBtn={toggleRightColumn} userProfile={userProfile}/>
                <div className="text-center">
                  <h4>Loading data...</h4>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                                <Section rightClickBtn={toggleRightColumn} ProjectName={project?.name}/>
                                <ButtonGroup className='material-shadow' style={{padding: '10px 20px 10px 0px'}}>
                  <UncontrolledDropdown>
                                        <DropdownToggle tag="button" className="btn btn-success material-shadow-none">
                      {selectedOption} <i className="mdi mdi-chevron-down"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      {options.slice(0, -1).map((option, index) => (
                        <DropdownItem
                          key={index}
                          onClick={() => handleSelect(option)}
                                                    style={option === 'All' ? {padding: '10px'} : {}}
                        >
                          {option}
                                                </DropdownItem>))}
                                            <DropdownItem divider/>
                                            <DropdownItem key="All" onClick={() => handleSelect("All")}>{options[options.length - 1]}</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </ButtonGroup>
                <Row>
                                    <Widget projectTotals={projectPrices} settledPrices={settledPrices} filter={selectedOption}/>
                </Row>
                <Row>
                  <Col>
                                        <Revenue settledPrices={settledPrices} filter={selectedOption}/>
                  </Col>
                </Row>
                                <Row>
                                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProjectReporting;
